/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Quick_Position_HintInputs */

const vi_warehouse_quick_position_hint = /** @type {(inputs: Warehouse_Quick_Position_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn vị trí lưu kho trước khi quét — mọi lần quét trong phiên sẽ nhập vào vị trí này.`)
};

/**

* @param {Warehouse_Quick_Position_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_quick_position_hint = /** @type {((inputs?: Warehouse_Quick_Position_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Quick_Position_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_quick_position_hint(inputs)
});